import { SHAPES, DIRECTION_SIDES, PATH_WEIGHTS } from '../modules/shapeLinks/components/ShapeModel';

function renderPath(cell, x, y, size, settings) {
  const sides = DIRECTION_SIDES[cell.direction] || {};
  const strokeColor = settings.colored && cell.color ? cell.color : '#000000';
  const strokeW = PATH_WEIGHTS[settings.pathWeight] || PATH_WEIGHTS.normal;
  let lines = '';

  const lineAttrs = `stroke="${strokeColor}" stroke-width="${strokeW}" stroke-linecap="round"`;

  if (sides.top) lines += `<line x1="12" y1="0" x2="12" y2="12" ${lineAttrs} />`;
  if (sides.bottom) lines += `<line x1="12" y1="12" x2="12" y2="24" ${lineAttrs} />`;
  if (sides.left) lines += `<line x1="0" y1="12" x2="12" y2="12" ${lineAttrs} />`;
  if (sides.right) lines += `<line x1="12" y1="12" x2="24" y2="12" ${lineAttrs} />`;

  return `<svg x="${x}" y="${y}" width="${size}" height="${size}" viewBox="0 0 24 24">${lines}</svg>`;
}

function getTextColor(settings, activeColor, filled) {
  if (settings.numberStyle === 'plain') return activeColor;
  if (filled) return '#ffffff';

  return activeColor;
}

function getShapeScale(shape) {
  const scales = {
    triangle: 0.9,
    triangle_down: 0.9,
    star: 0.9,
    pentagon: 0.85,
    hexagon: 0.85,
    octagon: 0.85,
    diamond: 0.9,
  };
  return scales[shape] ? `transform="scale(${scales[shape]})" transform-origin="12 12"` : '';
}

function renderShape(cell, x, y, size, settings) {
  const activeColor = settings.colored && cell.color ? cell.color : '#000000';
  const { filled } = cell;
  let inner = '';

  if (settings.shapeMode === 'number') {
    const fillStyle = filled ? activeColor : 'none';
    const textFill = getTextColor(settings, activeColor, filled);

    const backgrounds = {
      circle: `<circle cx="12" cy="12" r="10" fill="${fillStyle}" stroke="${activeColor}" stroke-width="1.5" />`,
      square: `<rect x="2" y="2" width="20" height="20" fill="${fillStyle}" stroke="${activeColor}" stroke-width="1.5" />`,
      rounded: `<rect x="2" y="2" width="20" height="20" rx="5" fill="${fillStyle}" stroke="${activeColor}" stroke-width="1.5" />`,
      plain: '',
    };

    const background = backgrounds[settings.numberStyle] || '';
    inner = `${background}<text x="12" y="16.5" text-anchor="middle" font-size="13" font-weight="bold" font-family="monospace" fill="${textFill}">${cell.value}</text>`;
  } else {
    const shapeData = SHAPES[cell.shape] || SHAPES.circle;
    const attrs = `fill="${filled ? activeColor : 'none'}" stroke="${activeColor}" stroke-width="${filled ? 0 : 2}"`;
    const transform = getShapeScale(cell.shape);

    const tags = {
      circle: `<circle cx="12" cy="12" r="8" ${attrs} />`,
      rect: `<rect x="4" y="4" width="16" height="16" rx="2" ${attrs} />`,
      polygon: `<polygon points="${shapeData.points}" ${transform} ${attrs} />`,
    };

    inner = tags[shapeData.tag] || tags.circle;
  }

  const iconSize = Math.round(size * 0.6);
  const offset = (size - iconSize) / 2;

  return `<svg x="${x + offset}" y="${y + offset}" width="${iconSize}" height="${iconSize}" viewBox="0 0 24 24">${inner}</svg>`;
}

function renderCell(cell, config) {
  const x = cell.positionx * config.cellSize;
  const y = cell.positiony * config.cellSize;
  const transparentBackground = config.transparentBackground ? 'none' : '#ffffff';
  const cellBg = cell.isBlocked ? config.gridColor : transparentBackground;

  let content = `<rect x="${x}" y="${y}" width="${config.cellSize}" height="${config.cellSize}" fill="${cellBg}" stroke="${config.gridColor}" stroke-width="1" />`;

  if (cell.isBlocked) return content;

  const isAnchor = cell.shape !== null || cell.value !== null;
  const hasPath = config.showAnswer && cell.direction !== null;

  if (isAnchor) {
    content += renderShape(cell, x, y, config.cellSize, config);
  } else if (hasPath) {
    content += renderPath(cell, x, y, config.cellSize, config);
  }

  return content;
}

export default function generateGameSVG(table, rows, cols, settings = {}) {
  const config = {
    cellSize: 60,
    padding: 20,
    showAnswer: true,
    colored: false,
    shapeMode: 'geometric',
    numberStyle: 'circle',
    gridColor: '#000000',
    transparentBackground: false,
    ...settings,
  };

  const svgWidth = cols * config.cellSize + config.padding * 2;
  const svgHeight = rows * config.cellSize + config.padding * 2;

  let svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
    <g transform="translate(${config.padding}, ${config.padding})">
  `;

  svg += table.map(cell => renderCell(cell, config)).join('');

  svg += '</g></svg>';
  return svg;
}
